import { useEffect } from 'react';

type PrintEventType = keyof Pick<
  WindowEventHandlersEventMap,
  'beforeprint' | 'afterprint'
>;

type UpdateDetail = (detail: HTMLDetailsElement) => void;

const updateDetails = (event: PrintEventType, updateDetail: UpdateDetail) => {
  const handlePrintEvent = () => {
    const details =
      document.body.querySelectorAll<HTMLDetailsElement>('details');
    details.forEach((detail) => updateDetail(detail));
  };

  window.addEventListener(event, handlePrintEvent);

  return () => window.removeEventListener(event, handlePrintEvent);
};

const useSetPrintListeners = function () {
  useEffect(() => {
    const removeBeforePrintListener = updateDetails('beforeprint', (detail) =>
      detail.setAttribute('open', ''),
    );
    const removeAfterPrintListener = updateDetails('afterprint', (detail) =>
      detail.removeAttribute('open'),
    );

    return () => {
      removeBeforePrintListener();
      removeAfterPrintListener();
    };
  }, []);
};

export default useSetPrintListeners;
